import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography} from "@material-ui/core"
import React, {useEffect, useState} from "react"
import {injectIntl} from "react-intl"
import XsButton from "../../global/ui/xsButton/xsButton"
import GlobalStore from "../../global/store/GlobalStore"
import MobxReactForm from "mobx-react-form"
import fields from "./deviceFields"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"
import {observer} from "mobx-react"
import DeviceDialogStore from "./DeviceDialogStore"
import XsAutocomplete from "../../global/ui/xsInput/xsAutocomplete"
import api from "../../global/actions/api"
import XsInput from "../../global/ui/xsInput/xsInput"
import XsSearchSelect from "../../global/ui/xsSearchSelect/xsSearchSelect"

function DeviceDialog() {
	const devicesWithCapacity = ["WTWA", "HPWA", "SCWA", "PVWA"]
	const devicesWithCatastral = ["PVNA", "PVWA"]

	const hooks = {
		onSubmit() {},
		onSuccess(form) {
			logger("SAVE", form.values())
			DeviceDialogStore.addDevice(form)
		},
		onError(form) {
			logger("CHYBY:", form.errors())
			GlobalStore.setNotificationMessage("Skontrolujte povinné polia", null, "error")
		}
	}

	const [deviceForm] = useState(new MobxReactForm(fields.load(), {plugins: {dvr: dvr(validatorjs)}, hooks}))

	useEffect(() => {
		DeviceDialogStore.formRef = deviceForm
	}, [])

	return (
		<Dialog
			id="createUniversalTemplate"
			open={DeviceDialogStore.isOpen}
			onClose={() => DeviceDialogStore.close()}
			className="xs-base-dialog dialog-newpatient"
			classes={{
				paper: "xs-paper-dialog xs-width-paper-900"
			}}
			disableBackdropClick={true}
			maxWidth="md"
		>
			<DialogTitle className="xs-info">
				<div className="xs-header">
					<div
						style={{position: "absolute", right: 24, top: 16, cursor: "pointer"}}
						onClick={() => {
							DeviceDialogStore.close()
						}}
					>
						<i className="fal fa-times fa-lg" />
					</div>
					<div className="xs-header-title">
						{!DeviceDialogStore.onlyDevice ? "Pridať miesto realizácie projektu" : "Pridať zariadenie"}
					</div>
				</div>
			</DialogTitle>
			<DialogContent style={{minWidth: 760}}>
				<Grid item container xs={12} className="mb-2" spacing={2}>
					{!DeviceDialogStore.onlyDevice && (
						<React.Fragment>
							<Grid item xs={12} md={4}>
								<XsAutocomplete
									field={deviceForm.$("cityId")}
									minLengthForSearch="1"
									api={api.loadEntityCity}
									inputRenderer={(obj) => obj.name_ext}
									saveValue={(obj) => obj.code}
									postAction={(obj) => {
										deviceForm.$("cityName").value = obj.name_ext
									}}
									onClear={() => {
										deviceForm.$("cityName").value = ""
									}}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								<XsInput field={deviceForm.$("street")} />
							</Grid>

							<Grid item xs={12} className="mb-1 mt-1">
								<Typography variant="body1" className="bold">
									Zariadenie
								</Typography>
							</Grid>
						</React.Fragment>
					)}

					<Grid item xs={12} md={4}>
						<XsSearchSelect
							field={deviceForm.$("device")}
							items={GlobalStore.CL["device"]}
							onChange={(obj) => {
								deviceForm.$("deviceCode").value = obj.code_ext
								deviceForm.$("deviceName").value = obj.name_ext

								const isCapacityRequired = devicesWithCapacity.includes(obj.code_ext)

								if (!isCapacityRequired) {
									deviceForm.$("deviceCapacity").value = ""
								}

								deviceForm.$("deviceCapacity").set("rules", isCapacityRequired ? "required" : "")

								const isCatastralRequired = devicesWithCatastral.includes(obj.code_ext)

								if (!isCatastralRequired) {
									deviceForm.$("deviceCadastralArea").value = ""
									deviceForm.$("deviceParcelNumber").value = ""
								}

								deviceForm.$("deviceCadastralArea").set("rules", isCatastralRequired ? "required" : "")
								deviceForm.$("deviceParcelNumber").set("rules", isCatastralRequired ? "required" : "")
							}}
						/>
					</Grid>
					<Grid item xs={12} md={3}>
						<XsInput field={deviceForm.$("devicePower")} />
					</Grid>
					{devicesWithCapacity.includes(deviceForm.$("deviceCode").value) && (
						<Grid item xs={12} md={3}>
							<XsInput field={deviceForm.$("deviceCapacity")} />
						</Grid>
					)}
					{devicesWithCatastral.includes(deviceForm.$("deviceCode").value) && (
						<React.Fragment>
							<Grid item xs={12} md={4}>
								<XsInput field={deviceForm.$("deviceCadastralArea")} />
							</Grid>
							<Grid item xs={12} md={3}>
								<XsInput field={deviceForm.$("deviceParcelNumber")} />
							</Grid>
						</React.Fragment>
					)}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Grid item container justify="flex-end" className="mr-2 mb-2">
					<Grid item>
						<XsButton
							className="xs-success"
							icon={<i className="fal fa-check" />}
							text="Uložiť"
							onClick={(e) => deviceForm.onSubmit(e)}
						/>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	)
}

export default injectIntl(observer(DeviceDialog))

